import { useEffect } from 'react';

const RoverIntegration = () => {
  useEffect(() => {
    // 1. Inject the Rover Template
    const template = document.createElement('template');
    template.id = 'rover-template-auth';
    template.setAttribute('data-rover-agent-action', 'v2');
    template.setAttribute('data-rover-a2w', 'https://agent.rtrvr.ai/v2/a2w/runs');
    template.innerHTML = '{"v":2,"a2w":"https://agent.rtrvr.ai/v2/a2w/runs","browser":{"prompt":"rover","shortcutId":"rover_shortcut","playbookId":"rover_playbook","engagementKind":"rover_kind"}}';
    document.body.appendChild(template);

    // 2. Inject the Rover Script
    const script = document.createElement('script');
    script.id = 'rover-script-auth';
    script.src = 'https://rover.rtrvr.ai/embed.js?v=9610ebfc-40b6-48e3-8999-642b90e57922';
    script.async = true;
    script.setAttribute('data-site-id', 'Clinchfirst-lGyhdQ');
    script.setAttribute('data-public-key', 'pk_site_tkx3ycxIIDV45J-HorlHMFpEgJPDvWedVdd5FDi5DZs');
    script.setAttribute('data-site-key-id', '9610ebfc-40b6-48e3-8999-642b90e57922');
    script.setAttribute('data-analytics-enabled', 'true');
    script.setAttribute('data-analytics-api-base', 'https://roverbook.rtrvr.ai');
    script.setAttribute('data-analytics-debug', 'false');
    document.body.appendChild(script);

    // Cleanup when the user logs out
    return () => {
      if (document.body.contains(template)) {
        document.body.removeChild(template);
      }
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      
      // Remove any injected UI elements from Rover
      const roverElements = document.querySelectorAll('rover-widget, [id^="rover-"], [data-rover-root]');
      roverElements.forEach(el => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });

      // Clear the global rover object
      if (window.rover) {
        if (typeof window.rover.destroy === 'function') {
          window.rover.destroy();
        }
        window.rover = undefined;
      }
    };
  }, []);

  return null; // This component doesn't render any visible UI directly
};

export default RoverIntegration;